/**
 * @author Chandra shekar
 * @Date: 2020-10-26 12:34:11
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2022-11-23 10:47:49
 */
import React, { PureComponent, Fragment } from 'react';
import OtpInput from 'react-otp-input';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Breadcrumb, Table, Button, Icon, Modal, Form, Input } from 'antd';
import { connect } from 'react-redux';

import Container from '../../components/Container';
import { AppWrappperHOC } from '../Root/HOC';
import { constants, utils, validationRules } from '../../devUtils';
import { FUND_TRANSFER_CONSTANTS, NsdlColumns, YblColumns } from './constants';
import { TransferFormNsdl, AddEditFormNsdl } from './NsdlFundTransfer';
import { FundTransferMapDispatchToProps, FundTransferMapStateToProps, FundTransferPropTypes } from './FundTransferDatahandler';
import { StyledOtpGeneration } from '../PayBalance/StyledPayBalance';
import { OtpScreen } from '../NetworkCards/OtpScreen';
import { NETWORKCARD_CONSTANTS } from '../NetworkCards/constants';

const { TextArea } = Input;

const { YES_BANK_DELETE_BENE, YES_BANK_IMPS } = NETWORKCARD_CONSTANTS;


class FundTransfer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalType: '',
      otherParams: {},
      OTP: '',
      showResendText: false,
      remainingTime: 60,
      otpType: '',
      transferValues: {},
    };
    const {
      onInitFundTransfer,
      onInitNsdlFundTransfer,
      SelectUserDetails: { bank_details = {} },
    } = props;
    this.columns = [
      ...YblColumns,
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        render: (value, record) => (
          <Fragment>
            <Button
              className="green-btn margin-r-1"
              disabled={!value}
              onClick={() => {
                onInitFundTransfer({ beneficiary_id: record.beneficiary_id }, { actionType: 'VIEW', apiMethod: 'GET' });
                this.handleModal('TRANSFER_FUND', record);
              }}
            >
              Transfer
            </Button>
            {!Object.keys(bank_details).length ?
              <Button
                disabled={!value}
                onClick={() => {
                  onInitFundTransfer({ beneficiary_id: record.beneficiary_id }, { actionType: 'VIEW', apiMethod: 'GET' });
                  this.handleModal('EDIT_LIMIT', record);
                }}
              >
                Edit
              </Button> : ''}
            <Button
              className="red-btn margin-l-1"
              onClick={() => this.handleModal('YBL_DELETE_BENEFICIARY', record)}
            >
              Delete
            </Button>
          </Fragment>
        ),
      },
    ];
    this.NsdlColumn = [
      ...NsdlColumns,
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        render: (value, record) => (
          <Fragment>
            <Button
              className="green-btn margin-r-1"
              disabled={value}
              onClick={() => {
                this.handleModal('TRANSFER_FUND', record);
              }}
            >
              Transfer
            </Button>
            {!Object.keys(bank_details).length ?
              <Button
                disabled={value}
                onClick={() => {
                  this.handleModal('EDIT_LIMIT', record);
                }}
              >Edit
              </Button> : ''}
            <Button
              className="red-btn margin-l-1"
              onClick={() => {
                onInitNsdlFundTransfer({ id: record.id }, { actionType: 'DELETE', apiMethod: 'POST' });
              }}
            >
              Delete
            </Button>
          </Fragment>
        ),
      },
    ];
    this.handleModal = this.handleModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOTPChange = this.handleOTPChange.bind(this);
    this.handleResendOTP = this.handleResendOTP.bind(this);
    this.yblVerifyLimitOtp = this.yblVerifyLimitOtp.bind(this);
    this.handleResendYblOtp = this.handleResendYblOtp.bind(this);
  }

  componentDidMount() {
    const { onInitFundTransfer,
      onInitUpdatedUserProfile,
      onInitNsdlFundTransfer,
      history: { location: { pathname } },
    } = this.props;
    if (pathname === constants.CONTANTS.LINK_FUND_TRANSFER) {
      onInitFundTransfer({}, { actionType: 'LISTING', apiMethod: 'GET' });
    } else if (pathname === constants.CONTANTS.LINK_NSDL_FUND_TRANSFER) {
      onInitNsdlFundTransfer({}, { actionType: 'LISTING', apiMethod: 'POST' });
    }
    onInitUpdatedUserProfile();
  }

  componentWillReceiveProps(nextProps) {
    const { BeneficiariesList: _BeneficiariesList,
      NsdlFundTransfer: _NsdlFundTransfer,
      BeneficiaryUpdate: _BeneficiaryUpdate,
      YblVerifyLimitOtpSuccess: _YblVerifyLimitOtpSuccess,
      onInitFundTransfer,
      onSetYblVerifyLimitOtp,
      YblDeleteBeneficiarySuccess: _YblDeleteBeneficiarySuccess,
      onSetYblDeleteBeneficiarySuccess,
      GetYesBankOtpSuccess: _GetYesBankOtpSuccess,
      SetChannelFlagSuccess: _SetChannelFlagSuccess,
      onSetChannelFlagSuccess,
      BeneficiaryCreate: _BeneficiaryCreate,
      SetFundTransfer: _SetFundTransfer,
    } = this.props;
    const { BeneficiariesList, BeneficiariesList: { status },
      NsdlFundTransfer, NsdlFundTransfer: { status: up_status },
      BeneficiaryUpdate, BeneficiaryUpdate: { status: fund_transfer_status },
      YblVerifyLimitOtpSuccess, YblVerifyLimitOtpSuccess: { status: verify_limit_otp_success, message },
      YblDeleteBeneficiarySuccess, YblDeleteBeneficiarySuccess: { status: delete_beneficiary_status },
      GetYesBankOtpSuccess, GetYesBankOtpSuccess: { status: yesBankOtpSuccessStatus },
      SetChannelFlagSuccess, SetChannelFlagSuccess: { status: channelFlagSuccessStatus },
      BeneficiaryCreate, BeneficiaryCreate: { status: fundTransferCreateStatus },
      SetFundTransfer, SetFundTransfer: { status: setFundTransferStatus },
    } = nextProps;
    if (!utils.isEqual(BeneficiariesList, _BeneficiariesList) && status) {
      this.handleModal();
    } else if (!utils.isEqual(NsdlFundTransfer, _NsdlFundTransfer) && up_status) {
      this.handleModal();
    } else if (!utils.isEqual(BeneficiaryUpdate, _BeneficiaryUpdate) && fund_transfer_status) {
      this.setState({ modalType: 'YBL_EDIT_BENEFICIARY' });
      this.startTimer();
    } else if (!utils.isEqual(BeneficiaryCreate, _BeneficiaryCreate) && fundTransferCreateStatus) {
      this.setState({ modalType: '' });
    } else if (!utils.isEqual(YblVerifyLimitOtpSuccess, _YblVerifyLimitOtpSuccess)) {
      if (verify_limit_otp_success && message) {
        onSetYblVerifyLimitOtp();
        this.handleModal();
        this.setState({ OTP: '' });
        onInitFundTransfer({}, { actionType: 'LISTING', apiMethod: 'GET' });
      }
    } else if (!utils.isEqual(YblDeleteBeneficiarySuccess, _YblDeleteBeneficiarySuccess) && delete_beneficiary_status) {
      this.setState({ OTP: '', otpType: '', modalType: '' });
      onSetYblDeleteBeneficiarySuccess();
      onInitFundTransfer({}, { actionType: 'LISTING', apiMethod: 'GET' });
    } else if (!utils.isEqual(GetYesBankOtpSuccess, _GetYesBankOtpSuccess) && yesBankOtpSuccessStatus) {
      this.setState({ modalType: 'YESBANK_OTP_SCREEN' });
      this.startTimer();
    } else if (!utils.isEqual(SetChannelFlagSuccess, _SetChannelFlagSuccess) && channelFlagSuccessStatus) {
      this.setState({ OTP: '', otpType: '', transferValues: {}, showResendText: false, remainingTime: 60 });
      onSetChannelFlagSuccess();
      this.setState({ modalType: '' });
    } else if (!utils.isEqual(SetFundTransfer, _SetFundTransfer) && setFundTransferStatus) {
      this.setState({ modalType: '' });
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();
    const {
      form: {
        validateFields,
      } = {},
      onInitFundTransfer,
      onInitNsdlFundTransfer,
      history: {
        location: {
          pathname,
        } = {},
      } = {},
    } = this.props;
    const {
      otherParams: { beneficiary_id, id },
      modalType,
    } = this.state;
    if (pathname === constants.CONTANTS.LINK_FUND_TRANSFER) {
      validateFields((err, values) => {
        const {
          bank_account_number = '',
          beneficiary_name = '',
          daily_transaction_limit = '',
          ifsc_code = '',
          max_monthly_limit = '',
        } = values;
        if (!err) {
          if (['ADD_BENEFICIARY', 'EDIT_LIMIT'].includes(modalType)) {
            onInitFundTransfer(!max_monthly_limit ? { beneficiary_name, bank_account_number, ifsc_code } : { beneficiary_id, max_monthly_limit, daily_transaction_limit },
              { apiMethod: 'POST', actionType: !max_monthly_limit ? 'CREATE' : 'UPDATE' });
          } else {
            this.setState({ transferValues: values });
            this.sendOtp(FUND_TRANSFER_CONSTANTS.YES_BANK_IMPS, { amount });
          }
        }
      });
    } else {
      validateFields((err, values) => {
        const {
          account_type = '',
          account_number = '',
          ifsc_code = '',
          name = '',
          imps_txn_amt = '',
          imps_payer_remarks = '',
        } = values;
        if (!err) {
          if (['ADD_BENEFICIARY', 'EDIT_LIMIT'].includes(modalType)) {
            onInitNsdlFundTransfer(id ? { id, account_type, account_number, ifsc_code, name } : values,
              { apiMethod: 'POST', actionType: id ? 'UPDATE' : 'CREATE' });
          } else {
            onInitNsdlFundTransfer({ id, imps_txn_amt, imps_payer_remarks },
              { apiMethod: 'POST', actionType: 'TRANSFER' });
          }
        }
      });
    }
  }

  handleResendOTP() {
    this.setState({ modalType: 'EDIT_LIMIT' });
    clearInterval(this.timer);
    this.setState({
      showResendText: false,
      remainingTime: 60,
    });
    this.startTimer();
  }

  handleResendYblOtp(type) {
    const {
      onGetOtp,
    } = this.props;
    clearInterval(this.timer);
    this.setState({
      showResendText: false,
      remainingTime: 60,
    });
    onGetOtp({ otp_type: type });
    this.setState({ otpType: type });
  }

  handleOTPChange(OTP) {
    this.setState({ OTP });
  }

  startTimer() {
    const {
      onGetOtpSuccess,
    } = this.props;
    this.timer = setInterval(() => {
      const { remainingTime } = this.state;
      if (remainingTime === 1) {
        clearInterval(this.timer);
        this.setState({ showResendText: true });
      }
      this.setState((prevState) => ({
        remainingTime: prevState.remainingTime - 1,
      }));
    }, 1000);
    onGetOtpSuccess();
  }

  yblVerifyLimitOtp() {
    const {
      onResetPopup,
      BeneficiaryUpdate: {
        otp_ref_number = '',
      } = {},
      onYblVerifyLimitOtp,
    } = this.props;
    const { OTP } = this.state;
    if (!OTP.length) {
      onResetPopup(constants.ALERT_FIELD_REQUIRED, 'error');
    } else if (OTP.length !== 6) {
      onResetPopup(constants.ALERT_OTP_MINIMUM_DIGITS, 'error');
    } else {
      const payload = {
        otp_ref_number,
        otp: OTP,
      };
      onYblVerifyLimitOtp(payload);
    }
  }

  handleModal(type, otherParams) {
    this.setState({ modalType: typeof (type) === 'string' ? type : '', otherParams: otherParams || {} });
  }

  sendOtp(type, otherParams = {}) {
    const {
      onGetOtp,
      BeneficiaryView: {
        beneficiary: {
          beneficiary_name = '',
        } = {},
      } = {},
    } = this.props;
    const { amount } = otherParams;
    switch (type) {
      case FUND_TRANSFER_CONSTANTS.YES_BANK_IMPS:
        onGetOtp({ otp_type: type, amount, beneficiary_name });
        break;
      default:
        onGetOtp({ otp_type: type });
        break;
    }
    this.setState({ otpType: type });
  }

  verifyOTP(type) {
    const {
      onInitFundTransfer,
      onInitYblDeleteBeneficiary,
    } = this.props;
    const {
      OTP,
      transferValues,
      otherParams: {
        beneficiary_id,
      } = {},
    } = this.state;
    switch (type) {
      case YES_BANK_IMPS:
        onInitFundTransfer({ ...transferValues, beneficiary_id, otp: OTP }, { apiMethod: 'POST', actionType: 'TRANSFER' });
        break;
      case YES_BANK_DELETE_BENE:
        onInitYblDeleteBeneficiary({ otp: OTP, beneficiary_id });
        break;
      default:
        break;
    }
  }

  renderYblDeleteBeneficiary() {
    const {
      isLoadingStatus,
    } = this.props;
    return (
      <Fragment>
        <h3 className="font-10">Are You Sure You Want To Delete The Beneficiary?</h3>
        <div className="text-right">
          <Button className="white-btn margin-r-2" onClick={this.handleModal}>NO</Button>
          <Button
            className="green-btn margin-r-2"
            loading={isLoadingStatus}
            onClick={() => this.sendOtp(FUND_TRANSFER_CONSTANTS.YES_BANK_DELETE)}
          >
            YES
          </Button>
        </div>
      </Fragment>
    );
  }

  renderTransferForm() {
    const {
      isLoadingStatus,
      form: {
        getFieldDecorator,
      } = {},
      BeneficiaryView: {
        beneficiary: {
          monthly_limit,
          monthly_limit_availed,
        } = {},
      } = {},
    } = this.props;
    const { otherParams: { bank_account_no } } = this.state;
    return (
      <Fragment>
        <h2>Transfer Fund</h2>
        <Form.Item className="margin-b-1" label="Account Number">
          {getFieldDecorator('bank_account_number', {
            initialValue: bank_account_no,
          })(
            <Input placeholder="Please enter account number" disabled />
          )}
        </Form.Item>
        <Form.Item className="margin-b-1" label="Amount" help={`Monthly transfer limit ${monthly_limit},  Monthly limit availed ${monthly_limit_availed}`}>
          {getFieldDecorator('amount', {
            rules: [validationRules.amount_field],
          })(
            <Input placeholder="Please enter amount" />
          )}
        </Form.Item>
        <Form.Item className="margin-b-1" label="Remarks">
          {getFieldDecorator('remarks')(
            <TextArea rows={4} placeholder="Enter remarks" />
          )}
        </Form.Item>
        <div className="text-right">
          <Button className="white-btn" onClick={this.handleModal}>
            Cancel
          </Button>
          <Button
            htmlType="submit"
            className="green-btn margin-l-1"
            loading={isLoadingStatus}
          >
            Transfer
          </Button>
        </div>
      </Fragment>
    );
  }

  renderOtpScreen(type) {
    const {
      SelectUserDetails: {
        phone = '',
      } = {},
      isLoadingStatus = false,
    } = this.props;
    const {
      OTP,
      showResendText,
      remainingTime,
    } = this.state;
    return (
      <OtpScreen
        type={type}
        MobileNumber={phone}
        isLoadingStatus={isLoadingStatus}
        OTP={OTP}
        showResendText={showResendText}
        remainingTime={remainingTime}
        handleOTPChange={this.handleOTPChange}
        handleResendOtp={() => this.handleResendYblOtp(type)}
        verifyOTP={() => this.verifyOTP(type)}
      />
    );
  }

  renderAddEditForm(type) {
    const { isLoadingStatus,
      form: { getFieldDecorator },
      BeneficiaryView: { beneficiary: { beneficiary_name, bank_account_no, ifsc_code, monthly_limit, monthly_limit_availed = 0 } = {} },
      SelectUserDetails: { bank_details: { account_number, beneficiary_status = false, beneficiary_name: b_name, ifsc_code: ifscCode } = {} },
    } = this.props;
    return (
      <Fragment>
        <h2>{type === 'EDIT_LIMIT' ? 'Edit' : 'Add New'} Beneficiary</h2>
        <Form.Item className="margin-b-1" label="Account Holder Name">
          {getFieldDecorator('beneficiary_name', {
            rules: [validationRules.mandatory],
            initialValue: beneficiary_name || b_name,
          })(
            <Input placeholder="Please enter account holder name" disabled={!!beneficiary_name || beneficiary_status} maxLength={20} />
          )}
        </Form.Item>
        <Form.Item className="margin-b-1" label="Account Number">
          {getFieldDecorator('bank_account_number', {
            rules: [validationRules.number_manadatory],
            initialValue: bank_account_no || account_number,
          })(
            <Input placeholder="Please enter account number" disabled={!!bank_account_no || beneficiary_status} />
          )}
        </Form.Item>
        <Form.Item className="margin-b-1" label="IFSC Code">
          {getFieldDecorator('ifsc_code', {
            rules: [validationRules.mandatory],
            initialValue: ifsc_code || ifscCode,
          })(
            <TextArea rows={4} placeholder="Please enter IFSC code" disabled={!!ifsc_code || beneficiary_status} />
          )}
        </Form.Item>
        {ifsc_code ?
          <Form.Item className="margin-b-1" label="Max Monthly Limit" help="Max. amount can be 200000">
            {getFieldDecorator('max_monthly_limit', {
              rules: [validationRules.amount_field],
              initialValue: monthly_limit ? Number(monthly_limit) : undefined,
            })(
              <Input placeholder="Enter Amount" maxLength={6} />
            )}
          </Form.Item> : ''}
        {ifsc_code ?
          <Form.Item className="margin-b-1" label="Max Transactions Per Day" help="Enter Number Of Transactions (Between 1-10)">
            {getFieldDecorator('daily_transaction_limit', {
              rules: [validationRules.amount_field],
              initialValue: monthly_limit_availed ? Number(monthly_limit_availed) : undefined,
            })(
              <Input placeholder="Enter number of transactions" maxLength={2} max={10} />
            )}
          </Form.Item> : ''}
        <div className="text-right">
          <Button className="white-btn" onClick={this.handleModal}>
            Cancel
          </Button>
          <Button
            htmlType="submit"
            className="green-btn margin-l-1"
            loading={isLoadingStatus}
          >{!monthly_limit ? 'Add Beneficiary' : 'Edit Beneficiary'}
          </Button>
        </div>
      </Fragment>
    );
  }

  renderModalUI() {
    const { history: { location: { pathname } },
      isLoadingStatus,
      form,
      NsdlFundTransfer,
      SelectUserDetails: {
        phone = '',
      } = {},
    } = this.props;
    const {
      modalType,
      otherParams,
      OTP,
      showResendText,
      remainingTime,
      otpType,
    } = this.state;
    const formattedPhone = `XXXXXX${phone.slice(-4)}`;
    if (pathname === constants.CONTANTS.LINK_FUND_TRANSFER) {
      switch (modalType) {
        case 'ADD_BENEFICIARY':
        case 'EDIT_LIMIT':
          return (
            <Form onSubmit={this.handleSubmit} layout="vertical">
              {this.renderAddEditForm(modalType)}
            </Form>
          );
        case 'YBL_EDIT_BENEFICIARY':
          return (
            <StyledOtpGeneration>
              <Card className="rounded otp-card margin-b-1">
                <Row align="top" type="flex" justify="start" gutter={10}>
                  <Col xs={24} sm={24} md={2} lg={2} xl={2}>
                    <Icon type="check-circle" theme="filled" className="check-icon" />
                  </Col>
                  <Col xs={24} sm={24} md={22} lg={22} xl={22}>
                    <p className="font-14">OTP has been Successfully sent to <strong> {formattedPhone} </strong>. {FUND_TRANSFER_CONSTANTS.COMPLETE_OTP_VERIFICATION}
                    </p>
                    <p className="font-12 text-red">
                      {FUND_TRANSFER_CONSTANTS.CONTACT_CUSTOMER_CARE}
                    </p>
                  </Col>
                </Row>
              </Card>
              <Row align="middle" type="flex" justify="center" gutter={10}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="margin-t-1 margin-b-1">
                  <OtpInput
                    containerStyle={{ justifyContent: 'center' }}
                    className="custom-otp-inputs"
                    value={OTP}
                    onChange={this.handleOTPChange}
                    numInputs={6}
                    separator={<span className="padding-1"></span>}
                    isInputNum
                  />
                </Col>
                <div>
                  {showResendText ? (
                    <span
                      role="presentation"
                      className="text-red"
                      style={{ cursor: 'pointer' }}
                      onClick={this.handleResendOTP}
                    >
                      Resend OTP
                    </span>
                  ) : (
                    <span>Resend OTP in 0 : {remainingTime} sec</span>
                  )}
                </div>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                  <Button
                    type="primary"
                    className="green-btn width-5 margin-t-1"
                    onClick={this.yblVerifyLimitOtp}
                    loading={isLoadingStatus}
                  >
                    Confirm
                  </Button>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <p className="font-14 nomargin-bottom margin-t-2">
                    Customer Service Number<br />
                    <strong>1860 500 1231</strong><br />
                    Timings - Monday to Saturday ( 10 AM - 7 PM)
                  </p>
                </Col>
              </Row>
            </StyledOtpGeneration>
          );
        case 'YBL_DELETE_BENEFICIARY':
          return this.renderYblDeleteBeneficiary();
        case 'YESBANK_OTP_SCREEN':
          return this.renderOtpScreen(otpType);
        case 'TRANSFER_FUND':
          return (
            <Form onSubmit={this.handleSubmit} layout="vertical">
              {this.renderTransferForm()}
            </Form>
          );
        default:
          return '';
      }
    }
    return (
      <Form onSubmit={this.handleSubmit} layout="vertical">
        {['ADD_BENEFICIARY', 'EDIT_LIMIT'].includes(modalType) ?
          <AddEditFormNsdl
            isLoadingStatus={isLoadingStatus}
            NsdlFundTransfer={NsdlFundTransfer}
            form={form}
            type={modalType}
            otherParams={otherParams}
            handleModal={this.handleModal}
          />
          :
          <TransferFormNsdl
            isLoadingStatus={isLoadingStatus}
            NsdlFundTransfer={NsdlFundTransfer}
            form={form}
            otherParams={otherParams}
            handleModal={this.handleModal}
          />
        }
      </Form>);
  }

  renderNsdlFundTransfer() {
    const { isLoadingStatus,
      history,
      onInitNsdlFundTransfer,
      NsdlFundTransferlist: { total_records, beneficiaries = [] },
      onSetNsdlFundTransfer,
      SelectUserDetails: { bank_details: { beneficiary_status = true } = {} },
    } = this.props;
    return (
      <Container className="margin-t-2">
        <Row align="top" type="flex" gutter={24}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-left">
            <h1 className="margin-b-1 font-20">Manage Zaggle Cards</h1>
            <Breadcrumb separator="<">
              <Breadcrumb.Item><Link to={constants.LINK_MY_PROFILE}>My Account</Link></Breadcrumb.Item>
              <Breadcrumb.Item><Link to={constants.LINK_PAY_BALANCE}>Manage cards</Link></Breadcrumb.Item>
              <Breadcrumb.Item>Fund Transfer</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Card className="rounded card-padding-20 noborder noshadow">
          <Row align="top" type="flex" gutter={32} className="padding-l-3 padding-r-3">
            <Col xs={24} sm={24} md={14} lg={14} xl={14}>
              <h1 className="margin-b-3 margin-r-3 font-20" style={{ display: 'inline-block' }}>Transfer Fund</h1>
              <Button className="grey-btn" onClick={() => history.goBack()}><Icon type="left" />Back to Expense Benefits card</Button>
            </Col>
            <Col xs={24} sm={24} md={10} lg={10} xl={10} className="text-right">
              <Button
                className="grey-btn"
                disabled={!beneficiary_status}
                onClick={() => {
                  onSetNsdlFundTransfer();
                  this.handleModal('ADD_BENEFICIARY');
                }}
              >
                Add Beneficiary
              </Button>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                rowKey="beneficiary_id"
                dataSource={beneficiaries}
                columns={this.NsdlColumn}
                loading={isLoadingStatus}
                pagination={{ total_records, onChange: (page) => onInitNsdlFundTransfer({ page }, { actionType: 'LISTING', apiMethod: 'POST' }) }}
                footer={() => (!beneficiary_status) ?
                  'Note: Please add the bank details from zagglepropel.com and avail the benefits of the card from zaggle.in or Zaggle Mobile App.' :
                  null
                }
              />
            </Col>
          </Row>
        </Card>
      </Container>
    );
  }

  renderFundTransfer() {
    const { isLoadingStatus,
      history,
      onInitFundTransfer,
      BeneficiariesList: { total_records, beneficiaries = [] },
      onSetFundTransfer,
      SelectUserDetails: { bank_details: { beneficiary_status = true } = {} },
    } = this.props;
    return (
      <Container className="margin-t-2">
        <Row align="top" type="flex" gutter={24}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-left">
            <h1 className="margin-b-1 font-20">Manage Zaggle Cards</h1>
            <Breadcrumb separator="<">
              <Breadcrumb.Item><Link to={constants.LINK_MY_PROFILE}>My Account</Link></Breadcrumb.Item>
              <Breadcrumb.Item><Link to={constants.LINK_PAY_BALANCE}>Manage cards</Link></Breadcrumb.Item>
              <Breadcrumb.Item>Fund Transfer</Breadcrumb.Item>
            </Breadcrumb>,
          </Col>
        </Row>
        <Card className="rounded card-padding-20 noborder noshadow">
          <Row align="top" type="flex" gutter={32} className="padding-l-3 padding-r-3">
            <Col xs={24} sm={24} md={14} lg={14} xl={14}>
              <h1 className="margin-b-3 margin-r-3 font-20" style={{ display: 'inline-block' }}>Transfer Fund</h1>
              <Button className="grey-btn" onClick={() => history.goBack()}><Icon type="left" />Back to Expense Benefits card</Button>
            </Col>
            <Col xs={24} sm={24} md={10} lg={10} xl={10} className="text-right">
              <Button
                className="grey-btn"
                disabled={!beneficiary_status}
                onClick={() => {
                  onSetFundTransfer();
                  this.handleModal('ADD_BENEFICIARY');
                }}
              >
                Add Beneficiary
              </Button>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Table
                rowKey="beneficiary_id"
                dataSource={beneficiaries}
                columns={this.columns}
                loading={isLoadingStatus}
                pagination={{ total_records, onChange: (page) => onInitFundTransfer({ page }, { actionType: 'LISTING', apiMethod: 'GET' }) }}
                footer={() => (!beneficiary_status) ?
                  'Note: Please add the bank details from zagglepropel.com and avail the benefits of the card from zaggle.in or Zaggle Mobile App.' :
                  null
                }
              />
            </Col>
          </Row>
        </Card>
      </Container>
    );
  }

  render() {
    const {
      history: { location: { pathname } },
    } = this.props;
    const {
      modalType,
    } = this.state;
    return (
      <Fragment>
        <Modal
          visible={!!modalType}
          onCancel={this.handleModal}
          size="sm"
          classname="default-popup"
          footer={null}
          maskClosable={false}
        >
          {modalType && this.renderModalUI()}
        </Modal>
        { pathname === constants.CONTANTS.LINK_NSDL_FUND_TRANSFER ?
          this.renderNsdlFundTransfer()
          :
          this.renderFundTransfer()
        }
      </Fragment>
    );
  }
}

FundTransfer.propTypes = FundTransferPropTypes;

const FundTransferWrapper = Form.create({ name: 'normal_admin' })(FundTransfer);
const component = connect(FundTransferMapStateToProps, FundTransferMapDispatchToProps)(AppWrappperHOC(FundTransferWrapper));
export { FundTransfer, FundTransferMapStateToProps, FundTransferMapDispatchToProps };
export default component;



// WEBPACK FOOTER //
// client/containers/FundTransfer/index.jsx